import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import PeopleIcon from "@mui/icons-material/People";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ConstructionIcon from "@mui/icons-material/Construction";
import { useHistory } from "react-router-dom";

export const ProyeccionMensualScreen = ({ data, ejercicio, periodo, columnas, permisos }) => {
  const history = useHistory();

  const getValue = (prop, obj) => {
    var importe = obj[prop.replace("[", "").replace("]", "")];
    importe = formatmiles(Number(importe));
    if (importe == "NaN") return "-";
    else return importe;
  };
  const getTotal = (prop) => {
    var importe = 0;
    for (let index = 0; index < data.length; index++) {
      var saldo = data[index][prop.replace("[", "").replace("]", "")];
      if (typeof saldo === "number") importe = Number(importe) + Number(saldo);
    }

    if (importe === 0) return "-";
    return formatmiles(importe);
  };
  const formatmiles = (number) => {
    return Math.floor((number == undefined ? 0 : number) / 1000).toLocaleString(
      "en-US"
    );
  };
  const getMonthName = (col) => {
    var number = col.split("-");
    var mes = number[1];
    if (mes == 1) return `Enero  ${number[0]}`;
    if (mes == 2) return `Febrero  ${number[0]}`;
    if (mes == 3) return `Marzo  ${number[0]}`;
    if (mes == 4) return `Abril  ${number[0]}`;
    if (mes == 5) return `Mayo  ${number[0]}`;
    if (mes == 6) return `Junio  ${number[0]}`;
    if (mes == 7) return `Julio  ${number[0]}`;
    if (mes == 8) return `Agosto  ${number[0]}`;
    if (mes == 9) return `Septiembre  ${number[0]}`;
    if (mes == 10) return `Octubre  ${number[0]}`;
    if (mes == 11) return `Noviembre    ${number[0]}`;
    if (mes == 12) return `Diciembre  ${number[0]}`;
  };

  const handleCellClick = (item, col) => {
    const mes = col.replace(/\[|\]/g, "");
    const tipo_cartera = item.tipo_cartera;
    let valor = getValue(col, item);

    if (valor === '-') {
      Swal.fire({
        icon: 'warning',
        title: 'PROYECCION DE RECUPERACION',
        text: 'No hay datos para mostrar en este mes.',
        confirmButtonText: 'Entendido'
      });
      return;
    }

    history.push("/Creditoycobranza/ReporteProyeccionMensual", { mes, tipo_cartera, ejercicio, periodo, permisos});
  };

  const handleCellClickTotal = (col) => {
    const mes = col.replace(/\[|\]/g, "");

    history.push("/Creditoycobranza/ReporteProyeccionTotal", { mes, ejercicio, periodo, permisos});
  };

  const getFilaTotal = (item) => {
    const total = columnas.reduce((sum, col) => { //suma columnas por cada filas
      const key = col.replace("[", "").replace("]", ""); // quita corchetes de los nombres de columna para no tomarlo como ["[2025-03]"]
      const value = parseFloat(item[key]) || 0; // toma el valor numerico de cada mes
      return sum + value;
    }, 0);
  
    return formatmiles(total);
  };

  const getTotalGeneral = () => {
    const total = data.reduce((totalSum, row) => { //suma los totales de cada fila para obtener el total
      const rowTotal = columnas.reduce((sum, col) => { //obtiene la suma de cada fila y se la pasa a total
        const key = col.replace("[", "").replace("]", "");
        const value = parseFloat(row[key]) || 0;
        return sum + value;
      }, 0);
      return totalSum + rowTotal;
    }, 0);
  
    return formatmiles(total);
  };

  // console.log(data)
  

  return (
    <div className="proyeccion-mensual-screen scroll">
      <table cellPadding={0} cellSpacing={0}>
        <thead>
          <tr>
            <th>Linea de Crédito</th>
            {columnas.map((item) => (
              <th key={item}>{getMonthName(item.replace("[", "").replace("]", ""))}</th>
            ))}
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id}> {/* Asegúrate de tener una clave única */}
              <td>
                <div>
                  {item.tipo_cartera === "Operación" ? (
                    <AgricultureIcon />
                  ) : item.tipo_cartera === "Especial" ? (
                    <PeopleIcon />
                  ) : (
                    <ConstructionIcon />
                  )}
                  {item.tipo_cartera}
                </div>
              </td>
              {columnas.map((col) => (
                <td
                  key={col}
                  className="celdas-data"
                  onClick={() => handleCellClick(item, col)}
                >
                  {getValue(col, item)}
                </td>
              ))}
              <td className="celdas-data total-fila">
                {getFilaTotal(item)}
              </td>
            </tr>
          ))}
          <tr>
            <td>
              <div>
                <AccountBalanceWalletIcon /> Total
              </div>
            </td>
            {columnas.map((col) => (
              <td key={col} className="celdas-data" onClick={() => handleCellClickTotal(col)}>{getTotal(col)}</td>
            ))}
            <td className="celdas-data total-final">
              {getTotalGeneral()}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
